import { Injectable } from '@angular/core';
import { Observable, of, delay, tap } from 'rxjs';
import { InstitutionService } from './institution.service';
import { Institution } from '../../interfaces/institution/institution.interface';
import { InstitutionSearchParam } from '../../interfaces/institution/institution-search-param.interface';
import { PageResponse } from '../../../../core/interfaces/page-response.interface';
import { InstitutionStats } from '../../interfaces/institution/institution-stats.interface';

@Injectable({
    providedIn: 'root'
})
export class InstitutionMockService extends InstitutionService {

    private mockInstitutions: Institution[] = [
        {
            uniqueId: 'inst-123',
            institutionName: 'Global Tech University',
            universityName: 'Global International University',
            officialEmailId: 'admin@globaltech.edu',
            mobileNumber: '9876543210',
            collegeApprovalNumber: 'AICTE-12345',
            yearOfEstablishment: '1995',
            address: '123 Education Boulevard, Tech Park',
            city: 'Silicon Valley',
            state: 'st-ka',
            pincode: '94025',
            country: 'cnt-usa-001',
            departmentsCount: 2,
            departments: [
                { 
                    name: 'Computer Science', 
                    code: 'CS', 
                    active: true, 
                    degrees: [
                        { name: 'B.E', active: true, noOfYears: 4 },
                        { name: 'M.Tech', active: true, noOfYears: 2 }
                    ]
                },
                { 
                    name: 'Electronics', 
                    code: 'EC', 
                    active: true, 
                    degrees: [
                        { name: 'B.E', active: true, noOfYears: 4 }
                    ]
                }
            ],
            websiteUrls: [
                { url: 'https://globaltech.edu', type: 'Official' }
            ],
            institutionDocuments: [],
            adminName: 'John Doe',
            adminEmail: 'john.doe@globaltech.edu',
            adminPhoneNumber: '9876543210',
            status: 'Active',
        },
        {
            uniqueId: 'inst-456',
            institutionName: 'Metropolitan Institute of Arts',
            universityName: 'Central State University',
            officialEmailId: 'info@mia.edu',
            mobileNumber: '8765432109',
            collegeApprovalNumber: 'UGC-98765',
            yearOfEstablishment: '1980',
            address: '456 Cultural Way, Downtown',
            city: 'London',
            state: 'st-tn',
            pincode: 'EC1A 1BB',
            country: 'cnt-india-001',
            departmentsCount: 2,
            departments: [
                { 
                    name: 'Fine Arts', 
                    code: 'FA', 
                    active: true, 
                    degrees: [
                        { name: 'B.F.A', active: true, noOfYears: 4 },
                        { name: 'M.F.A', active: true, noOfYears: 2 }
                    ]
                },
                { 
                    name: 'Architecture', 
                    code: 'AR', 
                    active: true, 
                    degrees: [
                        { name: 'B.Arch', active: true, noOfYears: 5 }
                    ]
                }
            ],
            websiteUrls: [
                { url: 'https://mia-london.edu', type: 'Official' }
            ],
            institutionDocuments: [],
            adminName: 'Jane Smith',
            adminEmail: 'jane.smith@mia.edu',
            adminPhoneNumber: '8765432109',
            status: 'Active'
        },
        {
            uniqueId: 'inst-789',
            institutionName: 'St. Andrews College of Medicine',
            universityName: 'National Medical Council',
            officialEmailId: 'admissions@standrews.med',
            mobileNumber: '7654321098',
            collegeApprovalNumber: 'NMC-55443',
            yearOfEstablishment: '2005',
            address: '789 Care Drive, Health City',
            city: 'Bangalore',
            state: 'st-ka',
            pincode: '560001',
            country: 'cnt-india-001',
            departmentsCount: 2,
            departments: [
                { 
                    name: 'General Medicine', 
                    code: 'GM', 
                    active: true, 
                    degrees: [
                        { name: 'M.B.B.S', active: true, noOfYears: 5 }
                    ]
                },
                { 
                    name: 'Pediatrics', 
                    code: 'PD', 
                    active: true, 
                    degrees: [
                        { name: 'M.D', active: true, noOfYears: 3 }
                    ]
                }
            ],
            websiteUrls: [
                { url: 'https://standrews.med', type: 'Official' }
            ],
            institutionDocuments: [],
            adminName: 'Robert Wilson',
            adminEmail: 'robert.wilson@standrews.med',
            adminPhoneNumber: '7654321098',
            status: 'Pending'
        },
        {
            uniqueId: 'inst-111',
            institutionName: 'Imperial Business School',
            universityName: 'Imperial Education Trust',
            officialEmailId: 'dean@imperial.biz',
            mobileNumber: '6543210987',
            collegeApprovalNumber: 'MBA-11223',
            yearOfEstablishment: '2010',
            address: '32 Financial District, Sky Tower',
            city: 'Dubai',
            state: 'st-dub-001',
            pincode: '00000',
            country: 'cnt-uae-001',
            departmentsCount: 2,
            departments: [
                { 
                    name: 'Business Administration', 
                    code: 'MBA', 
                    active: true, 
                    degrees: [
                        { name: 'MBA', active: true, noOfYears: 2 }
                    ]
                },
                { 
                    name: 'Finance', 
                    code: 'FIN', 
                    active: true, 
                    degrees: [
                        { name: 'M.Com', active: true, noOfYears: 2 }
                    ]
                }
            ],
            websiteUrls: [
                { url: 'https://imperial.biz', type: 'Official' }
            ],
            institutionDocuments: [],
            adminName: 'Michael Brown',
            adminEmail: 'michael.brown@imperial.biz',
            adminPhoneNumber: '6543210987',
            status: 'Active'
        },
        {
            uniqueId: 'inst-222',
            institutionName: 'Nordic Institute of Design',
            universityName: 'Scandinavian Design Council',
            officialEmailId: 'hello@nordicdesign.se',
            mobileNumber: '5432109876',
            departmentsCount: 2,
            collegeApprovalNumber: 'DES-44556',
            yearOfEstablishment: '2015',
            address: '15 Creative Plaza, North Side',
            city: 'Stockholm',
            state: 'st-stk-001',
            pincode: '111 20',
            country: 'cnt-swe-001',
            departments: [
                { 
                    name: 'Industrial Design', 
                    code: 'ID', 
                    active: true, 
                    degrees: [
                        { name: 'B.Des', active: true, noOfYears: 4 }
                    ]
                },
                { 
                    name: 'UX/UI Design', 
                    code: 'UX', 
                    active: true, 
                    degrees: [
                        { name: 'M.Des', active: true, noOfYears: 2 }
                    ]
                }
            ],
            websiteUrls: [
                { url: 'https://nordicdesign.se', type: 'Official' }
            ],
            institutionDocuments: [],
            adminName: 'Sarah Miller',
            adminEmail: 'sarah.miller@nordicdesign.se',
            adminPhoneNumber: '5432109876',
            status: 'Active'
        }
    ];

    constructor() {
        super();
    }

    override findAll(searchParam: InstitutionSearchParam): Observable<PageResponse<Institution>> {
        let filtered = [...this.mockInstitutions];

        if (searchParam.searchTerm) {
            const term = searchParam.searchTerm.toLowerCase();
            filtered = filtered.filter(inst =>
                inst.institutionName.toLowerCase().includes(term) ||
                inst.universityName?.toLowerCase().includes(term) ||
                inst.city?.toLowerCase().includes(term) ||
                inst.officialEmailId?.toLowerCase().includes(term) ||
                inst.adminName?.toLowerCase().includes(term) ||
                inst.adminEmail?.toLowerCase().includes(term) ||
                inst.adminPhoneNumber?.toLowerCase().includes(term)
            );
        }

        if (searchParam.status) {
            filtered = filtered.filter(inst => inst.status === searchParam.status);
        }

        const size = searchParam.size || 10;
        const page = searchParam.page || 0;

        const start = page * size;
        const end = start + size;
        const paginatedContent = filtered.slice(start, end);

        return this.wrapRequest(
            of({
                content: paginatedContent,
                page: {
                    number: page,
                    size: size,
                    totalElements: filtered.length,
                    totalPages: Math.ceil(filtered.length / size)
                }
            }).pipe(delay(1000)),
            false,
            'Failed to fetch institutions'
        );
    }

    override find(id: string): Observable<Institution> {
        const institution = this.mockInstitutions.find(i => i.uniqueId === id);
        return this.wrapRequest(
            of(institution!).pipe(delay(1000)),
            false,
            'Failed to fetch institution'
        );
    }

    override create(data: Partial<Institution>): Observable<Institution> {
        const newInstitution = { ...data, uniqueId: 'inst-' + Math.random().toString(36).substring(7) } as Institution;
        this.mockInstitutions.push(newInstitution);

        return this.wrapRequest(
            of(newInstitution).pipe(delay(1500)),
            false, // Will show toast conditionally or we handle success via the wrapRequest's interceptor? 
            // wait, wrapRequest(showSuccess = false). I will set showSuccess = true so it pops up the success message for creation.
            // In base service, showSuccess = false by default. Let me pass true for creating.
            'Failed to create institution'
        );
    }

    override update(id: string, data: Partial<Institution>): Observable<Institution> {
        const index = this.mockInstitutions.findIndex(i => i.uniqueId === id);
        if (index !== -1) {
            this.mockInstitutions[index] = { ...this.mockInstitutions[index], ...data } as Institution;
        }
        return this.wrapRequest(
            of(this.mockInstitutions[index]).pipe(delay(1500)),
            false,
            'Failed to update institution'
        );
    }

    override delete(id: string): Observable<void> {
        this.mockInstitutions = this.mockInstitutions.filter(i => i.uniqueId !== id);
        return this.wrapRequest(
            of(undefined).pipe(delay(1000)).pipe(tap(() => {
                this.toast.success('Institution deleted successfully');
            })),
            false,
            'Failed to delete institution'
        );
    }

    override uploadDocument(institutionId: string, documentType: string, file: File): Observable<any> {
        const mockResponse = {
            fileName: file.name,
            sasURL: `https://mockstorage.blob.core.windows.net/documents/${file.name}?sasToken`,
            size: `${(file.size / (1024 * 1024)).toFixed(2)} MB`,
            documentType: documentType
        };

        return this.wrapRequest(
            of(mockResponse).pipe(delay(1500)).pipe(tap(() => {
                this.toast.success(`${documentType} uploaded successfully`);
            })),
            false,
            'Failed to upload document'
        );
    }

    override getStats(id: string): Observable<InstitutionStats> {
        const mockStats: InstitutionStats = {
            institutionUniqueId: id,
            activeBatches: 2,
            totalRegisteredStudents: 450,
            recentBatches: [
                { name: '2026 Graduating', registered: 250, total: 250 },
                { name: '2025 Pre-Final', registered: 200, total: 250 }
            ],
            totalInvited: 450,
            joinedPercentage: 89,
            activeEvents: [
                { name: 'Grab SDE Drive', bookedSlots: 180, totalSlots: 200, statusColor: 'green' },
                { name: 'AirAsia Frontend', bookedSlots: 120, totalSlots: 150, statusColor: 'orange' }
            ],
            averagePackage: '6.2L',
            placementRate: 78,
            departmentRates: [
                { departmentName: 'CSE Department', placementRate: 85 },
                { departmentName: 'Mech Department', placementRate: 72 }
            ],
            totalStaff: 12,
            activeStaff: 10,
            recentStaff: [
                { name: 'Dr. Sarah Wilson', status: 'ACTIVE', joinedDate: '2024-01-15' },
                { name: 'Prof. Michael Brown', status: 'ACTIVE', joinedDate: '2024-02-10' },
                { name: 'Jane Smith', status: 'PENDING', joinedDate: '2024-03-01' }
            ]
        };

        return this.wrapRequest(
            of(mockStats).pipe(delay(1000)),
            false,
            'Failed to fetch institution stats'
        );
    }

    override updateStatus(id: string, status: boolean): Observable<void> {
        const index = this.mockInstitutions.findIndex(i => i.uniqueId === id);
        if (index !== -1) {
            this.mockInstitutions[index].status = status ? 'Active' : 'Inactive';
        }
        return this.wrapRequest(
            of(undefined).pipe(delay(1000)).pipe(tap(() => {
                this.toast.success('Institution status updated successfully');
            })),
            false,
            'Failed to update institution status'
        );
    }

    override updatePassword(uniqueId: string, password: string): Observable<void> {
        return this.wrapRequest(
            of(undefined).pipe(delay(1000)).pipe(tap(() => {
                this.toast.success('Institution password updated successfully');
            })),
            false,
            'Failed to update institution password'
        );
    }

    override staffReinvite( institutionUniqueId: string, mapperUniqueId: string ): Observable<boolean> {        
        return this.wrapRequest(
            of(true).pipe(delay(1000)).pipe(tap(() => {
                this.toast.success('Success');
            })),
            false,
            'Failed to re-invite staff member'
        );
    }
}
